import { ApproverGroup } from 'ts/interfaces/approverGroup.interface'

export const titleName = (inputTitle: string) => {
  switch (inputTitle) {
    case 'REVISE':
      return 'Revise'
    case 'ACCEPT':
      return 'Accept'
    case 'RESTART':
      return 'Restart'
    default:
      return ''
  }
}

export const toSentenceCase = (sentence: string) => {
  if (!sentence) {
    return ''
  }
  return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase()
}

export const toNumber = (inputValue: string | number | null | undefined): number => {
  if (inputValue === null || inputValue === undefined) {
    return 0
  }
  if (typeof inputValue === 'number' && !isNaN(inputValue)) {
    return inputValue
  } else if (typeof inputValue === 'string' && !isNaN(parseFloat(inputValue))) {
    return parseFloat(inputValue)
  } else {
    console.error('Invalid input value:', inputValue)
    return 0
  }
}

export type ApproverRole = {
  isActiveApprover: boolean
  approverName: string
  approverEmail: string
  approverEmployeeNumber: string | number
  roleTitle: string
  groupId: string | number
  decisionTypeCode: string
  decisionReasonCode: string
  levels: any
}

export const getRoles = (data: ApproverGroup[]) => {
  const list: ApproverRole[] = []

  data.forEach((group) => {
    group.approvers.forEach((approver) =>
      approver.approverDetails.forEach((item) => {
        list.push({
          isActiveApprover: approver.isActiveApprover,
          approverName: item.approverName,
          approverEmail: item.approverEmail,
          approverEmployeeNumber: item.approverEmployeeNumber,
          roleTitle: group.roleTitle,
          groupId: group.groupId,
          decisionTypeCode: group.decisionTypeCode,
          decisionReasonCode: group.decisionReasonCode,
          levels: group.levels[0],
        })
      })
    )
  })
  return list
}

export const isValidDealNumber = (num: string | undefined) => {
  if (!num) return false
  return /^\d{8}$/.test(num)
}

/**
 * Formats a timestamp into a human-readable "last refresh" label
 * @param lastRefreshAt - Unix timestamp in milliseconds of last refresh, or null if no refresh yet
 * @param now - Current Unix timestamp in milliseconds
 * @returns Formatted string like "Last refresh 5 min ago." or null if no refresh has occurred
 *
 * @example
 * formatLastRefreshLabel(Date.now() - 120000, Date.now())
 * // Returns: "Last refresh 2 min ago."
 */
export const formatLastRefreshLabel = (
  lastRefreshAt: number | null,
  now: number
): string | null => {
  if (!lastRefreshAt) {
    return null
  }

  const diffMs = now - lastRefreshAt
  const minutes = Math.floor(diffMs / 60000)

  let timeText: string

  if (minutes < 1) {
    timeText = '< 1 min ago.'
  } else if (minutes < 60) {
    timeText = minutes === 1 ? '1 min ago.' : `${minutes} min ago.`
  } else {
    const hours = Math.floor(minutes / 60)
    timeText = hours === 1 ? '1 hour ago.' : `${hours} hours ago.`
  }

  return `Last refresh ${timeText}`
}
